import api from '@/lib/api';
import type { PaginatedResponse, RetailLookup, RetailLookupType } from '@pms/shared';

// ─── Query / payload types ────────────────────────────────────────────────────

export interface ListRetailLookupsQuery {
  type: RetailLookupType;
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
}

export interface CreateRetailLookupPayload {
  type: RetailLookupType;
  propertyId: string;
  name: string;
  isActive?: boolean | undefined;
}

export interface UpdateRetailLookupPayload {
  name?: string | undefined;
  isActive?: boolean | undefined;
}

// ─── API functions ────────────────────────────────────────────────────────────
// The lookups controller is a single tabbed surface keyed by a `:type` PATH
// segment (`/v1/retail/lookups/:type`), accepting the singular enum value.

export async function fetchRetailLookups(
  query: ListRetailLookupsQuery,
): Promise<PaginatedResponse<RetailLookup>> {
  const { type, ...params } = query;
  const { data } = await api.get<PaginatedResponse<RetailLookup>>(`/retail/lookups/${type}`, {
    params,
  });
  return data;
}

export async function createRetailLookup(
  payload: CreateRetailLookupPayload,
): Promise<RetailLookup> {
  const { type, ...body } = payload;
  const { data } = await api.post<RetailLookup>(`/retail/lookups/${type}`, body);
  return data;
}

export async function updateRetailLookup(
  type: RetailLookupType,
  id: string,
  payload: UpdateRetailLookupPayload,
): Promise<RetailLookup> {
  const { data } = await api.patch<RetailLookup>(`/retail/lookups/${type}/${id}`, payload);
  return data;
}

export async function deleteRetailLookup(type: RetailLookupType, id: string): Promise<void> {
  await api.delete(`/retail/lookups/${type}/${id}`);
}
